import SafeHtml from '~/vue_shared/directives/safe_html';
export default {
    name: 'SuggestionDiffRow',
    directives: {
        SafeHtml
    },
    props: {
        line: {
            type: Object,
            required: true
        }
    },
    computed: {
        displayAsCell () {
            return !(this.line.rich_text || this.line.text);
        },
        lineType () {
            return this.line.type;
        }
    }
};
